import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import DraggableTab from '../draggable-tab/Draggable-Tab';
import Stack from '@mui/material/Stack';
import { Tab, Tabs } from '@material-ui/core';

function normalizeSlideNames(tabs) {
  const idRegex = /^slide_\d+$/i;
  const labelRegex = /^Slide\s+\d+$/i;

  tabs.forEach((tab, idx) => {
    if (tab.id && idRegex.test(tab.id)) {
      tab.id = `slide_${idx + 1}`;
    }
    if (tab.label && labelRegex.test(tab.label)) {
      tab.label = `Slide ${idx + 1}`;
    }
  });
}

const DraggableTabsList = (props) => {
  const { activeTabIndex, tabs, onDragEnd, onTabChange } = props;
  
  normalizeSlideNames(tabs);
  const renderTabList = (droppableProvided) => (
    <Tabs
      onChange={onTabChange}
      variant='fullWidth'
      indicatorColor='primary'
      aria-label='tabs'
      textColor='primary'
      className='tabs'
      value={activeTabIndex}
    >
      {tabs.map((tab, index) => {
        const slideRegex = /^Slide\s+\d+$/i;
        const displayLabel = slideRegex.test(tab.label)
          ? `Slide ${index + 1}`
          : tab.label;

        return (
          <DraggableTab
            label={displayLabel}
            value={tab.value}
            index={index}
            key={index}
            child={<Tab label={displayLabel} key={index} />}
          />
        );
      })}
      {droppableProvided ? droppableProvided.placeholder : null}
    </Tabs>
  );

  return (
    <Stack direction="column">
      <DragDropContext onDragEnd={onDragEnd}>
        <div style={{ display: 'flex', overflow: 'auto' }}>
        <Droppable droppableId='1' direction='horizontal'>
            {(droppableProvided) => (
            <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                {renderTabList(droppableProvided)}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    </Stack>
  );
};

export default DraggableTabsList;
